import { useState } from 'react';
import { Button, Contact, Nav, Section, TitleWrapper } from '../components'
import { Modal } from '../components/Modal/Modal'
import "../../src/styles/globals.scss"
import "../../src/styles/variables.scss";

const Behandelingen = () => {
    const [activeModal, setActiveModal] = useState<string>('Massages');

    return (
        <>
            <Section>
                <div className="button-wrapper">
                    <Button buttonColor={activeModal === 'Massages' ? 'primary' : 'secondary'} buttonText='Massages' onClick={() => setActiveModal('Massages')}/>
                    <Button buttonColor={activeModal === 'Gezichtsbehandelingen' ? 'primary' : 'secondary'} buttonText='Gezichtsbehandelingen' onClick={() => setActiveModal('Gezichtsbehandelingen')}/>
                    <Button buttonColor={activeModal === 'Hybrid Brows' ? 'primary' : 'secondary'} buttonText='Hybrid Brows' onClick={() => setActiveModal('Hybrid Brows')}/>
                </div>
                <Nav behandelingPage/>
                <Modal activeModal={activeModal} />
            </Section>
            <Section backgroundColor="var(--color-dark-green)" id="contact">
                <TitleWrapper textAlign="center" title="Waar kun je mij vinden?" subtitle="Contact" />
                <Contact/>
            </Section>
            <footer>
                <div className="hannet"><p>Handmade by Hannet ©</p></div>
            </footer>
        </>
)
}

export default Behandelingen